// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XeGX","col":"styles_col__1JEs-"};